import React from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";

import Box from "@material-ui/core/Box";
import useConstants from "@hooks/useConstants";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Autocomplete from "@components/Global/Custom/Autocomplete";
import TextField, {
	ZipcodeTextField,
} from "@components/Global/Custom/TextField";
import Button from "@material-ui/core/Button";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import Divider from "@material-ui/core/Divider";
import Chip from "@material-ui/core/Chip";
import useStaticContext from "@hooks/useStaticContext";

const CostsHero = () => {
	const classes = useStyles("Costs");

	const {
		showSearch,
		showCTA,
		heroMaxWidth,
		h1,
		h2,
		backgroundImage,
		placeholder,
	} = useConstants("CostsHeroViewModel");

	const { mobile, desktop } = backgroundImage;

	const { app } = useStaticContext();

	const { city, state } = app.location || {};

	return (
		<React.Fragment>
			<section className={classes.hero}>
				<picture className={classes.picture}>
					<source
						srcSet={`${mobile} 300w, ${mobile} 768w, ${desktop} 1280w, ${desktop} 3200w`}
						sizes="100vw"
					/>
					<img
						sizes="100vw"
						srcSet={`${mobile} 300w, ${mobile} 768w, ${desktop} 1280w, ${desktop} 3200w`}
						src={desktop}
						alt={h1}
						className={classes.backgroundImage}
						fetchpriority="high"
					/>
				</picture>

				<Box
					height="100%"
					display={{ xs: "flex", sm: "none" }}
					alignItems="flex-end"
					position="relative"
					color="#FFF"
					pt={6}
					pb={6}
					pr={4}
					pl={4}
				>
					<Box display={"flex"} flexDirection={"column"}>
						{city && (
							<Box mb={2}>
								<Chip
									label={`${city}, ${state}`}
									style={{ opacity: 0.6, fontWeight: 700 }}
								/>
							</Box>
						)}

						<Box
							component={"h1"}
							fontSize={{ xs: 28, sm: 44 }}
							lineHeight={1.3}
							fontWeight={700}
							mt={0}
							mb={{ xs: 0, sm: 2 }}
						>
							<Box dangerouslySetInnerHTML={{ __html: h1 }} />
						</Box>
					</Box>
				</Box>

				<Box
					width="100%"
					left={0}
					top="50%"
					pr={2}
					pl={2}
					className={classes.heroBox}
				>
					<Container maxWidth="md">
						<Box
							display={{ xs: "none", sm: "block" }}
							borderRadius={12}
							boxShadow={5}
							bgcolor="#FFF"
							className={classes.heroBoxContent}
							maxWidth={heroMaxWidth}
						>
							{city && (
								<Box mb={2}>
									<Chip
										label={`${city}, ${state}`}
										style={{ opacity: 0.6, fontWeight: 700 }}
									/>
								</Box>
							)}

							<Box
								component={"h1"}
								fontSize={{ xs: 28, sm: 44 }}
								lineHeight={1.3}
								fontWeight={700}
								mt={0}
								mb={{ xs: 0, sm: 3 }}
							>
								<Box dangerouslySetInnerHTML={{ __html: h1 }} />
							</Box>

							<Box color={"grey.700"} lineHeight={1.5} mb={5} fontSize={18}>
								<Box
									lineHeight={1.6}
									dangerouslySetInnerHTML={{ __html: h2 }}
								/>
							</Box>

							{showSearch ? (
								<form>
									<Grid container spacing={4}>
										<Grid item xs={12}>
											<Autocomplete
												//onSelect={serviceOnSelectHandler}
												id="service"
												TextFieldProps={{
													groupId: "desktop",
													InputProps: {
														classes: {
															adornedStart: classes.autocompleteAdornedStart,
															input: classes.autocompleteInputRoot,
														},
													},
													inputProps: {
														"autoCorrect": "off",
														"spellCheck": "false",
														"aria-label": "Enter service",
													},
													placeholder: placeholder,
													variant: "outlined",
												}}
											/>
										</Grid>

										<Grid item xs={12}>
											<Button
												fullWidth
												//onClick={() => getStartedHandler("desktop")}
												size={"large"}
												variant="contained"
												color="primary"
												disableElevation
												className={classes.joinButton}
											>
												Get costs
											</Button>
										</Grid>
									</Grid>
								</form>
							) : showCTA ? (
								<Button
									//onClick={() => getStartedHandler("desktop")}
									href={"/"}
									size={"large"}
									variant="contained"
									color="primary"
									disableElevation
									className={classes.joinButton}
								>
									Get free estimates
								</Button>
							) : (
								<></>
							)}
						</Box>
					</Container>
				</Box>
			</section>

			<Box
				display={{ xs: "block", sm: "none" }}
				p={4}
				maxWidth="100%"
				bgcolor="#FFF"
			>
				<Box color={"grey.700"} lineHeight={1.5} mb={5}>
					<Box lineHeight={1.6} dangerouslySetInnerHTML={{ __html: h2 }} />
				</Box>

				{showSearch ? (
					<form>
						<Grid container spacing={4}>
							<Grid item xs={12}>
								<Autocomplete
									//onSelect={serviceOnSelectHandler}
									id="service-mobile"
									TextFieldProps={{
										groupId: "mobile",
										inputProps: {
											"autoCorrect": "off",
											"spellCheck": "false",
											"aria-label": "Enter service",
										},
										InputProps: {
											classes: {
												adornedStart: classes.autocompleteAdornedStart,
												input: classes.autocompleteInputRoot,
											},
										},
										placeholder: placeholder,
										variant: "outlined",
									}}
								/>
							</Grid>

							<Grid item xs={12}>
								<Button
									fullWidth
									//onClick={() => getStartedHandler("mobile")}
									size={"large"}
									variant="contained"
									color="primary"
									disableElevation
									className={classes.joinButton}
								>
									Get costs
								</Button>
							</Grid>
						</Grid>
					</form>
				) : showCTA ? (
					<Button
						href={"/"}
						fullWidth
						//onClick={() => getStartedHandler("mobile")}
						size={"large"}
						variant="contained"
						color="primary"
						disableElevation
						className={classes.joinButton}
					>
						Get free estimates
					</Button>
				) : (
					<></>
				)}

				<Box pt={7}>
					<Divider light={true} />
				</Box>
			</Box>
		</React.Fragment>
	);
};

CostsHero.propTypes = {};
export default CostsHero;
